module.exports = __webpack_public_path__ + "img/Signs.9f1654c1.jpg";